import React, { useState, useEffect } from "react";
// import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
// import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
// import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

import Angela1C from "../Common/Angela/Angela1C";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class GilSupplierDashboard extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("");
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  render() {
    return (
      <>
        <SessionError visible={this.state.loginError} />
        <div
          style={{
            background: "#000000",
            paddingTop: 10,
            //   backgroundImage:
            //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
          }}
        >
          <div>
            <Col span={24}>
              <div
                style={{
                  margin: "10px",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    color: "#bdc3c7",
                    fontSize: 28,
                    fontWeight: 400,
                    textAlign: "center",
                    margin: "0px 0px 30px 0px",
                  }}
                >
                  Amardeep Industries
                </div>
                <div
                  style={{
                    color: "#bdc3c7",
                    fontSize: 20,
                    fontWeight: 400,
                    textAlign: "left",
                    margin: "30px 0px 10px 0px",
                  }}
                >
                  Supplier Rating 
                </div>

                {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                <Row style={{ background: "#000000" }}>
                  <Col style={{ width: "20%" }}></Col>
                  <Col style={{ width: "20%" }}></Col>
                  <Col style={{ width: "20%" }}></Col>
                  <Col style={{ width: "20%" }}></Col>
                </Row>

                {/* _______Row No 1________ */}
                <Row style={{ background: "#000000" }}>
                  <Col style={{ width: "25%" }}>
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                          }}
                        >
                          <Angela1C
                            divId={"Dict001A"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              chartGroup: "GilSupplierDashboard",
                              parent: "Dict001",
                              child: "Dict001A",
                            }}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                          }}
                        >
                          <Angela1C
                            divId={"Dict001B"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              chartGroup: "GilSupplierDashboard",
                              parent: "Dict001",
                              child: "Dict001B",
                            }}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                          }}
                        >
                          <Angela1C
                            divId={"Dict002A"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              chartGroup: "GilSupplierDashboard",
                              parent: "Dict001",
                              child: "Dict002A",
                            }}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                          }}
                        >
                          <Angela1C
                            divId={"Dict002B"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              chartGroup: "GilSupplierDashboard",
                              parent: "Dict001",
                              child: "Dict002B",
                            }}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col style={{ width: "25%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict003"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          dictName: "Dict003",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "25%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict004"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          dictName: "Dict004",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "25%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict005"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          dictName: "Dict005",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row>
                {/* _______Row No 2________ */}
                {/* <Row style={{ background: "#000000" }}>
                  <Col style={{ width: "12.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict006"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict001",
                          child: "Dict006",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "12.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict007"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict001",
                          child: "Dict007",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row> */}
                {/* _______Row No 3________ */}


                <div
                  style={{
                    color: "#bdc3c7",
                    fontSize: 20,
                    fontWeight: 400,
                    textAlign: "left",
                    margin: "30px 0px 10px 0px",
                  }}
                >
                  4M Performance 
                </div>


                <Row style={{ background: "#000000" }}>
                  <Col style={{ width: "12.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict009A"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict008",
                          child: "Dict009A",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "12.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict009B"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict008",
                          child: "Dict009B",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                  <Col style={{ width: "12.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict009C"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict008",
                          child: "Dict009C",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "25%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <ZenVerBarChart
                        divId={"Dict011"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          dictName: "Dict011",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row>
                {/* _______Row No 4________ */}
                <Row style={{ background: "#000000" }}>
                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict012"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict012",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict013"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict013",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict014"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict014",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict015"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict015",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict016"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict016",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict017"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict017",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict018"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict018",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict019"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict019",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict020"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict020",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict021"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict021",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict022"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict022",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>

                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict023"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict023",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                  <Col style={{ width: "7.5%" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: "10px 10px 10px 10px",
                      }}
                    >
                      <Angela1C
                        divId={"Dict12MTD"}
                        api={"/chart/charttemplate"}
                        urlData={{
                          chartGroup: "GilSupplierDashboard",
                          parent: "Dict012",
                          child: "Dict12MTD",
                        }}
                        onChange={(data) => this.changeBasicGraph(data)}
                      />
                    </div>
                  </Col>
                </Row>

                {/* Houdini_DivData */}
              </div>
            </Col>
          </div>
        </div>
      </>
    );
  }
}

export default GilSupplierDashboard;
